export const ClimbingTypeMixin = {
  data () {
    return {
      climbingTypeColors: {
        sport_climbing: '#3a71c7',
        bouldering: '#ffcb00',
        pan: '#9c27b0',
        multi_pitch: '#ff5656',
        trad_climbing: '#e92b2b',
        aid_climbing: '#d40000',
        deep_water: '#86ccdd',
        via_ferrata: '#3cc770',
        fun_climbing: '#ff80b2'
      }
    }
  }
}
